import typography, { type Typography } from './typography';

export const STYLES = {
    display: 'inline-flex',
    cursor: 'pointer',
    lineHeight: '1em',
    textDecoration: 'none',
    userSelect: 'none',
    outline: 'none',
    transition: 'var(--transition-primary)',
};

const TEXT_BUTTON_BASE_THEME = {
    color: 'var(--button-tertiery-text)',
    backgroundColor: 'transparent',
    border: 'none',
    hover: {
        color: 'var(--button-tertiery-text-hover)',
        backgroundColor: 'transparent',
        border: 'none',
    },
    active: {
        color: 'var(--button-tertiery-text-active)',
        backgroundColor: 'transparent',
        border: 'none',
    },
    disabled: {
        color: 'var(--button-tertiery-text-disabled)',
        backgroundColor: 'transparent',
        border: 'none',
        pointerEvents: 'none',
        cursor: 'not-allowed',
    },
    focusOutlineColor: 'var(--button-tertiery-text-focus-outline)',
    sizes: {
        small: {
            typography: ['Primary/Mobile/13_100_510_-1', null, null, null, 'Primary/15_120_510_-1'],
        },
        large: {
            typography: ['Primary/Mobile/18_120_510_-3', null, null, null, 'Primary/20_120_510_-3'],
        },
    },
};

const FILLED_SECONDARY_THEME = {
    color: 'var(--button-secondary-text)',
    backgroundColor: 'var(--button-secondary-background)',
    border: 'none',
    hover: {
        color: 'var(--button-secondary-text-hover)',
        backgroundColor: 'var(--button-secondary-background)',
        border: 'none',
    },
    active: {
        color: 'var(--button-secondary-text-active)',
        backgroundColor: 'var(--button-secondary-background)',
        border: 'none',
    },
    disabled: {
        color: 'var(--button-secondary-text-disabled)',
        backgroundColor: 'var(--button-secondary-background-disabled)',
        border: 'none',
        pointerEvents: 'none',
        cursor: 'not-allowed',
    },
    focusOutlineColor: 'none',
    sizes: {
        small: {
            typography: ['Primary/Mobile/13_100_510_-1', null, null, 'Primary/Mobile/15_100_510_-1'],
        },
        large: {
            typography: ['Primary/Mobile/18_120_510_-3', null, null, 'Primary/Mobile/20_120_510_-3'],
        },
    },
};

export const THEMES = {
    textButtonUnderline: TEXT_BUTTON_BASE_THEME,
    textButton: TEXT_BUTTON_BASE_THEME,
    filledSecondary: FILLED_SECONDARY_THEME,
};

export type ButtonStyles = typeof STYLES;
export type ButtonThemes = typeof THEMES;
export type ButtonTheme = keyof ButtonThemes;
